import { Button, ButtonMode, Loader } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './LoadMoreButton.module.scss';

interface LoadMoreButtonProps {
  onClick: () => void;
  isLoading?: boolean;
}

const cx = classNames.bind(styles);

const LoadMoreButton = ({ onClick, isLoading }: LoadMoreButtonProps): React.ReactElement => {
  return (
    <div className={cx('body')}>
      {isLoading ? (
        <Loader className={cx('loader')} color="primary" text={null} />
      ) : (
        <Button mode={ButtonMode.PRIMARY} onClick={onClick} dataTestId="load-more-btn">
          Load more
        </Button>
      )}
    </div>
  );
};

export default LoadMoreButton;
